export default defineTemplateMeta( {
  middleware: ["registration-journey"],
} );
